@if (isLogged()) {
    <div class="navbar shadow-lg p-2" [class.showios]="isIOS()">
        <a [routerLink]="['/dashboard']" (click)="hidemenu()" class="fade-in d-none d-lg-block" routerLinkActive="active">
            <div class="d-none d-lg-block">
                <img src="./assets/img/iso-libresalud.png" alt="Libre Salud" class="logo d-none d-lg-block">
            </div>
        </a>
        <a [routerLink]="['/dashboard']" (click)="hidemenu()" class="fade-in" routerLinkActive="active">
            <i class="bi bi-house"></i><span>Inicio</span>
        </a>
        <a [routerLink]="['/my-account']" (click)="hidemenu()" class="fade-in" [class.active]="isActiveAccount('/my-account')">
            <i class="bi bi-person"></i><span>Mi Cuenta</span>
        </a>
        <!-- Botón central para abrir/cerrar modal de acciones -->
        <a (click)="openmodal()"
            class="fade-in solicitar onlymobile"
            [class.solicitar-on]="modalOpen()"
            [class.active]="isActiveAccount('/order-emergencias') || isActiveAccount('/comercio') || isActiveAccount('/pedido') || isActiveAccount('/condiciones') || isActiveAccount('/resumen-order-comercio') || isActiveAccount('/especialidad') || isActiveAccount('/zona-geografica') || isActiveAccount('/fecha-turno') || isActiveAccount('/resumen-order-prestador')">
            <i class="bi bi-plus-circle"></i>
        </a>
        <!-- Botón flotante TURNOS -->
        @if (showPrestador()) {
            <a (click)="turnos()" class="fade-in btn-add-navbar btn-add-prestador" id="btn-navbar-prestador" style="--i:1">
                <div class="btn-add-circle">
                    <i class="bi bi-person-fill-add"></i>
                </div>
                <span class="btn-add-label">Turno</span>
            </a>
        }
        <!-- Botón flotante EMERGENCIA -->
        @if (showEmergency()) {
            <a (click)="emergencias()" class="fade-in btn-add-navbar btn-add-emergency" id="btn-navbar-emergency" style="--i:1">
                <div class="btn-add-circle emergency">
                    <i class="bi bi-phone-vibrate-fill"></i>
                </div>
                <span class="btn-add-label">Emergencia</span>
            </a>
        }
        <!-- Botón flotante EMERGENCIA -->
        @if (showComercio()) {
            <a (click)="pedidos()" class="fade-in btn-add-navbar btn-add-comercio" id="btn-navbar-comercio" style="--i:1">
                <div class="btn-add-circle">
                    <i class="bi bi-bag-plus-fill"></i>
                </div>
                <span class="btn-add-label">Tienda</span>
            </a>
        }
        <a [routerLink]="['/notifications']" (click)="hidemenu()" class="fade-in" routerLinkActive="active">
            @if (hasNewNotification()) {
                <i class="bi bi-circle-fill showNotifications"></i>
            }
            <i class="bi bi-bell"></i><span>Notificaciones</span>
        </a>
        <a [routerLink]="['/more']" (click)="hidemenu()" class="fade-in" [class.active]="isActiveAccount('/more') || isActiveAccount('/pedidos') || isActiveAccount('/turnos') || isActiveAccount('/acerca-de') || isActiveAccount('/ayuda') || isActiveAccount('/delete-account')">
            <i class="bi bi-list"></i><span>Más</span>
        </a>
        <!-- Botón central (versión desktop) -->
        <a (click)="openmodal()" 
            class="fade-in solicitar onlydesktop" 
            [class.solicitar-on]="modalOpen()" 
            [class.active]="isActiveAccount('/order-emergencias') || isActiveAccount('/comercio') || isActiveAccount('/pedido') || isActiveAccount('/condiciones') || isActiveAccount('/resumen-order-comercio') || isActiveAccount('/especialidad') || isActiveAccount('/zona-geografica') || isActiveAccount('/fecha-turno') || isActiveAccount('/resumen-order-prestador')">
            <i class="bi bi-plus-circle"></i>
        </a>
    </div>
}